// /src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './styles.css'; // Import the CSS file
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
